interface LayoutProps {
  children: React.ReactNode
}

function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex justify-center px-4">
      <div className="w-full max-w-[85rem]">{children}</div>
    </div>
  )
}

export default Layout
